import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import type React from "react"
import { memo } from "react"

interface ArticleTableActionsProps {
  onAdd: () => void
  onRefresh: () => void
  loading?: boolean
}

const ArticleTableActions: React.FC<ArticleTableActionsProps> = memo(({ onAdd, onRefresh, loading = false }) => {
  return (
    <div className="flex grow items-center justify-end gap-2">
      <Tooltip title="Thêm bài viết mới">
        <Button type="primary" size="small" icon={<PlusOutlined />} onClick={onAdd}>
          Thêm mới
        </Button>
      </Tooltip>

      <Tooltip title="Tải lại dữ liệu">
        <Button type="default" size="small" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading} />
      </Tooltip>
    </div>
  )
})

ArticleTableActions.displayName = "ArticleTableActions"

export default ArticleTableActions
